export default __webpack_public_path__ + "491872029bcea906e1c4f01c572a9ec3.png";